<div class="modal-wrapper sm:max-w-md md:max-w-lg">

    <div class="flex items-center justify-between">
        <h3 class="modal-title">
            {{'BUSINESS_ONBOARDING.ENTER_REFERENCE_ID' | translate}}</h3>
        <!-- Cancel Icon -->
        <img src="assets/icons/cancel.svg" alt="Cancel Icon" class="modal-close-icon rtl:mr-auto! rtl:ml-0!" (click)="close()" />
    </div>


    <!-- Form -->
    <form [formGroup]="referenceForm" class="space-y-4 text-start" (ngSubmit)="submitReferenceId()">

        <!-- Reference Id Field -->
        <app-input-field type="number" label="{{ 'BUSINESS_ONBOARDING.REFERENCE_ID' | translate }}"
            placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" [control]="referenceIdControl"></app-input-field>

        <!-- Continue Button -->
        <app-button [text]="'BUSINESS_ONBOARDING.CONTINUE' | translate" type="submit" variant="primary" size="lg"
            extraClass="mt-4" [disabled]="referenceIdControl.invalid"></app-button>
    </form>
</div>